import { motion } from "framer-motion";

import { Container } from "@/components/ui/Container";
import { fadeUp, staggerContainer, staggerItem } from "@/lib/motion";

interface PageHeroProps {
  eyebrow?: string;
  title: string;
  description?: string;
}

/** Lightweight inner-page hero (no large image), with subtle accent backdrop. */
export function PageHero({ eyebrow, title, description }: PageHeroProps) {
  return (
    <section className="relative isolate overflow-hidden border-b border-border bg-muted section-accent">
      <Container className="py-16 pt-28 sm:py-20 sm:pt-32 lg:py-24 lg:pt-40">
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          animate="visible"
          className="max-w-3xl"
        >
          {eyebrow && (
            <motion.span
              variants={staggerItem}
              className="inline-block text-sm font-semibold uppercase tracking-wider text-accent"
            >
              {eyebrow}
            </motion.span>
          )}
          <motion.h1
            variants={staggerItem}
            className="mt-3 text-4xl font-bold tracking-tight text-foreground sm:text-5xl text-balance"
          >
            {title}
          </motion.h1>
          {description && (
            <motion.p
              variants={fadeUp}
              className="mt-5 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg"
            >
              {description}
            </motion.p>
          )}
        </motion.div>
      </Container>
    </section>
  );
}
